import { motion } from "framer-motion";
import { Plus, ArrowUpRight } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useI18n } from "@/i18n/I18nContext";
import { formatPrice } from "./specIcons";
import { imgUrl } from "@/lib/api";

export default function ProductCard({ product, index, onQuickView, categoryName }) {
  const { t } = useI18n();
  const navigate = useNavigate();

  return (
    <motion.article
      data-testid={`product-card-${product.id}`}
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1], delay: (index % 4) * 0.08 }}
      className="group flex flex-col"
    >
      {/* 
        REVİZE 1: Çerçeve oranını 'aspect-square' yerine 'aspect-[4/3]' yatay dikdörtgen yaptık.
        Bu oran, yan yana iki tişörtün olduğu görseller için çok daha uygundur ve alt/üst boşlukları yok eder.
      */}
      <div className="relative aspect-[4/3] overflow-hidden bg-secondary">
        <img
          src={imgUrl(product.images?.[0])}
          alt={product.name}
          loading="lazy"
          className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
        />
        {product.featured && (
          <span className="absolute start-3 top-3 bg-primary px-2.5 py-1 text-[10px] font-bold uppercase tracking-wider text-primary-foreground">
            {t("products.featured")}
          </span>
        )}
        <button
          data-testid={`quick-view-${product.id}`}
          onClick={() => onQuickView(product)}
          className="absolute inset-x-0 bottom-0 flex translate-y-full items-center justify-center gap-2 bg-foreground/95 py-3.5 text-sm font-semibold text-background backdrop-blur transition-transform duration-300 group-hover:translate-y-0"
        >
          <Plus className="h-4 w-4" />
          {t("products.quickView")}
        </button>
      </div>

      <div className="mt-4 flex items-start justify-between gap-3">
        <button
          data-testid={`product-title-${product.id}`}
          onClick={() => navigate(`/urun/${product.id}`)}
          className="text-start"
        >
          <h3 className="font-display text-lg font-semibold leading-tight tracking-tight transition-colors group-hover:text-primary">
            {product.name}
          </h3>
          <p className="mt-1 text-xs uppercase tracking-widest text-muted-foreground">
            {categoryName || product.category}
          </p>
        </button>
        <button
          onClick={() => navigate(`/urun/${product.id}`)}
          aria-label="detail"
          className="mt-1 flex h-8 w-8 shrink-0 items-center justify-center border border-border transition-colors hover:bg-foreground hover:text-background"
        >
          <ArrowUpRight className="h-4 w-4 rtl:rotate-[-90deg]" />
        </button>
      </div>
      <p className="mt-2 text-sm font-medium text-muted-foreground">
        {t("products.from")} <span className="text-foreground">{formatPrice(product.price)}</span>
      </p>
    </motion.article>
  );
}